import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

import Loader from '../../../components/Loader';
import BusinessWeeklyItem from '../../../components/BusinessWeeklyItem';

import { ROUTES } from '../../../constants/routes';
import AdminDocWrapper from '../AdminDocWrapper';
import { statusOptions } from '../../../constants/document';

class BusinessWeeklyListPage extends Component {
  componentWillMount() {
    if (!this.props.list.length) this.props.getListAdmin();
  }

  render() {
    const { loading, list, allCount, remove } = this.props;

    return (
      <>
        {loading && <Loader type="fixed" />}
        <Container fluid className="py-2 border-bottom">
          <Row className="justify-content-between align-items-center">
            <Col>
              <h2 className="display-2 mb-0">Business Weekly</h2>
            </Col>
            <Col className="text-right">
              <Link
                to={`${ROUTES.ADMIN_BUSINESS_WEEKLY_ITEM_PARAM}new`}
                className="btn btn-primary btn-icon"
              >
                <span className="btn-inner--icon">
                  <i className="ni ni-fat-add" />
                </span>
                <span className="btn-inner--text">New</span>
              </Link>
            </Col>
          </Row>
        </Container>
        <Container className="py-4">
          <AdminDocWrapper
            getListAdmin={this.props.getListAdmin}
            allCount={allCount}
            remove={remove}
            filterShape={{
              status: {
                label: 'Status',
                type: 'switcher',
                initialValue: '',
                options: statusOptions,
              },
              issue: {
                label: 'Issue #',
                type: 'number',
                initialValue: '',
              },
              search: {
                label: 'General search',
                type: 'text',
                initialValue: '',
              },
            }}
            headerList={[
              { title: '#', colStyle: { width: '5%' } },
              {
                title: 'issue #',
                isSortable: true,
                isAssociated: true,
                colStyle: { width: '15%' },
                dbName: 'number',
              },
              {
                title: 'Name',
                isSortable: true,
                isAssociated: true,
                colStyle: { width: '33%' },
                dbName: 'title',
              },
              {
                title: 'status',
                isSortable: true,
                colStyle: { width: '15%' },
              },
              {
                title: 'date',
                isSortable: true,
                dbName: 'publishedAt',
                colStyle: { width: '15%' },
              },
              {
                title: 'action',
                centered: true,
                colStyle: { width: '15%' },
              },
            ]}
            rowsList={list.map((item, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <BusinessWeeklyItem key={i} item={item} isAdmin index={i + 1} />
            ))}
          />
        </Container>
      </>
    );
  }
}

export default BusinessWeeklyListPage;
